<script>
    import Icon from '../icon/Icon.svelte'
    import Spinner from '../spinner/Spinner.svelte'
    import { fetchAudio } from 'util/TextToSpeechUtil'
    import { addActiveAudio, removeActiveAudio } from 'stores/audioStore'
    import AudioUtil from 'util/AudioUtil'

    export let url
    export let showCallback = () => {}
    export let hideCallback = () => {}
    export let maxAttempts = 16
    export let hasButtonStyling = false

    const audio = new Audio()
    audio.defaultPlaybackRate = 0.95
    let isLoading = false
    let isPlayingAudio = false

    audio.addEventListener('play', () => {
        AudioUtil.stopAllAudio(audio)
        isPlayingAudio = true
        addActiveAudio(audio)
        showCallback()
    })

    audio.addEventListener('pause', () => {
        isPlayingAudio = false
        removeActiveAudio(audio)
        hideCallback()
    })
    audio.addEventListener('ended', () => {
        isPlayingAudio = false
        removeActiveAudio(audio)
        hideCallback()
    })

    export function toggleTextToSpeech() {
        if (isLoading) {
            return
        }

        if (isPlayingAudio) {
            audio.pause()
            return
        }

        startAudio()
    }

    async function startAudio(attempt = 0) {
        isLoading = true;
        showCallback()

        attempt++

        try {
            const blob = await fetchAudio(url, true)

            Backbone.View.layout.closeStatus()

            audio.src = URL.createObjectURL(blob)
            await audio.play()

            isLoading = false
        } catch (error) {
            if (error.error_code === 35202) {
                if (attempt > maxAttempts) {
                    isLoading = false
                    Backbone.View.layout.openStatus(
                        window.i18n.gettext('The audio could not be downloaded. Try again later.')
                    )
                    hideCallback()
                } else if (_.isString(url)) {
                    // Only start another attempt if url is a string (single URL). Retry logic for list of URLs
                    // is handled in TextToSpeechUtil
                    setTimeout(() => {
                        startAudio(attempt)
                    }, 500)
                    if (attempt === 4) {
                        Backbone.View.layout.openStatus(error.displayMessage, 'loading', {noHide: true})
                    }
                }
            } else {
                if (error?.displayMessage) {
                    Backbone.View.layout.openStatus(error.displayMessage);
                } else {
                    Backbone.View.layout.closeStatus()
                }

                isLoading = false;
                hideCallback();
            }
        }
    }
</script>

<button class="status-icon" class:button={hasButtonStyling} on:click={toggleTextToSpeech}>
    <div class="icon-holder">
        {#if isLoading}
            <div class="spinner">
                <Spinner isInsideButton={true}></Spinner>
            </div>
        {:else}
            {#if isPlayingAudio}
                <Icon name="stop"></Icon>
            {:else}
                <Icon name="volume-up"></Icon>
            {/if}
        {/if}
    </div>
</button>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.status-icon {
  display: flex;
  position: absolute;
  inset: 0;
  border-radius: 8px;
}
.status-icon .icon-holder {
  margin: auto;
}
.status-icon :global(svg) {
  width: 16px;
  height: 16px;
  display: flex;
}

.button {
  font-size: 14px;
  border-radius: 12px;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  transition: background 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.button :global(svg) {
  width: 16px;
  height: 16px;
  fill: currentColor;
  transition: fill 0.1s cubic-bezier(0.215, 0.61, 0.355, 1);
  flex-shrink: 0;
}
.button {
  background-color: #fff;
  color: #122d40;
  border: solid 1px hsl(40, 4%, 84%);
}
.button :global(svg) {
  fill: #122d40;
}
.button > :global(*) {
  display: inline-flex;
}
.button > :global(*:empty) {
  display: none;
}
.button {
  position: unset;
  inset: unset;
}</style>
